s-select {
  display: block;

  &[readonlyinput] ul,
  &[nosearch] ul {
    border-radius: 4px;

    &.bottom-border-radius-none {
      border-radius: 4px 4px 0 0;
    }
  }

  ul {
    background-color: var(--color-white);
    border: 1px solid var(--color-gray-light);
    border-radius: 0 0 4px 4px;
    list-style: none;
    max-height: 203px;
    min-width: 100%;
    overflow: auto;
    top: -1px;
    z-index: 100;

    &.bottom-border-radius-none {
      border-radius: 0;
    }

    > li:not([data-ref='nomatch']) {
      align-items: center;
      background-color: var(--color-white);
      border-radius: 4px;
      display: flex;
      height: 1.875rem;
      margin: var(--margin-xs);
      padding: var(--padding-xs);
      word-break: break-all;

      span {
        white-space: pre;
      }

      &:focus {
        outline: none;
      }

      &:not([data-ref='loading']):not([data-ref='nomatch']):not([aria-disabled='true']) {
        cursor: pointer;
      }
      &:not([data-ref='loading']):not([data-ref='nomatch']):not([aria-disabled='true']):hover {
        background-color: var(--color-gray-lightest);
      }
      &.visually-focused {
        box-shadow: 0 0 0 2px var(--color-white), 0 0 0 4px var(--color-gray-dark);
      }
      &[data-selected='true'],
      &[data-selected='true']:hover {
        background-color: var(--color-blue-lighter);
      }

      &[aria-disabled='true'] {
        color: var(--color-gray-light);
        cursor: not-allowed;
      }

      &[data-ref='loading'] {
        padding: var(--padding-lg);
      }
    }

    > li[data-ref='nomatch'] {
      color: var(--color-gray-darkest);
      padding: var(--padding-sm);
    }
  }

  div[data-ref='select-ul-container'] {
    height: 100%;
    min-width: 100%;
    position: absolute;
    top: calc(100% - 1px);
    white-space: nowrap;
  }

  [slot='sticky-footer'] {
    background-color: var(--color-white);
    border: 1px solid var(--color-gray-light);
    border-radius: 0 0 4px 4px;
    border-top: 0;
    min-height: 2.625rem;
    position: relative;
    top: -1px;
    z-index: 1;
  }

  div[data-ref='select-input-container'] {
    align-items: center;
    border: 1px solid var(--color-gray-light);
    border-radius: 4px;
    cursor: text;
    display: flex;
    flex-basis: 25%;
    flex-wrap: wrap;
    min-height: 2.375rem;
    padding-right: 2.25rem;

    &:focus {
      border: 1px solid var(--color-blue-dark);
      box-shadow: 0 0 0 1px var(--color-blue-dark);
      outline: none;
    }

    &:focus:not(:focus-visible) {
      outline: none;
    }

    /* Show focus styles on keyboard focus. */
    &:focus-visible {
      border: 1px solid var(--color-blue-dark);
      box-shadow: 0 0 0 1px var(--color-blue-dark);
    }

    &.contains-clear-button {
      padding-right: 4.875rem;
    }

    &:hover:not(:focus) {
      border-color: var(--color-gray-medium);
    }
  }

  div[data-ref='search-input-div'] {
    background-color: var(--color-white);
    border: 1px solid var(--color-gray-light);
    border-radius: 4px 4px 0 0;
    padding: var(--padding-xs);
    z-index: 100;
  }

  span[data-ref='select-value'] {
    margin-left: var(--margin-xs);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  button[data-ref='deselect-all-button'] {
    height: 2.25rem;
    position: absolute;
    right: 2.625rem;
    top: 0;
    width: 2.25rem;

    &:focus {
      border: 1px solid var(--color-blue-dark);
      box-shadow: 0 0 0 1px var(--color-blue-dark);
      outline: none;
    }

    &:focus:not(:focus-visible) {
      outline: none;
    }

    /* Show focus styles on keyboard focus. */
    &:focus-visible {
      border: 1px solid var(--color-blue-dark);
      box-shadow: 0 0 0 1px var(--color-blue-dark);
    }
  }

  div[data-ref='disclosure-icon'] {
    align-items: center;
    display: flex;
    height: 2.25rem;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    width: 2.25rem;
  }

  span[data-ref='placeholder'] {
    color: var(--color-gray-dark);
    font-style: italic;
    margin-left: var(--margin-xs);
  }

  &[multiple] {
    span[data-ref='tag-text'] {
      white-space: pre;
    }

    span[data-ref='selection-count-span'] {
      margin-left: var(--margin-xs);
    }

    li:not([data-ref='nomatch']):not([data-ref='loading']) {
      padding-left: 1.75rem;

      &::before {
        content: '';
        height: 1rem;
        left: 0.375rem;
        position: absolute;
        top: 0.4375rem;
        width: 1rem;
      }

      &[data-selected='true'],
      &[data-selected='true']:hover {
        background-color: var(--color-blue-lighter);
        &::after {
          align-items: center;
          border-radius: 2px;
          color: var(--color-blue-dark);
          content: '\e933'; // check
          display: flex;
          font-family: 's-icons';
          font-size: 1rem;
          height: 1rem;
          justify-content: center;
          left: 0.375rem;
          position: absolute;
          top: 0.4375rem;
          width: 1rem;
        }
      }
    }
  }

  &.warning,
  &.warning:hover {
    div[data-ref='select-input-container'] {
      background-color: var(--color-yellow-lightest);
      border-color: var(--color-yellow-darker);
    }
  }

  &.error,
  &.error:hover {
    div[data-ref='select-input-container'] {
      background-color: var(--color-red-lightest);
      border-color: var(--color-red-dark);
    }
  }

  &.success,
  &.success:hover {
    div[data-ref='select-input-container'] {
      background-color: var(--color-green-lightest);
      border-color: var(--color-green-medium);
    }
  }

  &.success,
  &.warning,
  &.error {
    div[data-ref='select-input-container'] {
      &:focus {
        border: 1px solid var(--color-blue-dark);
        box-shadow: 0 0 0 1px var(--color-blue-dark);
        outline: none;
      }
      &:focus:not(:focus-visible) {
        outline: none;
      }

      /* Show focus styles on keyboard focus. */
      &:focus-visible {
        border: 1px solid var(--color-blue-dark);
        box-shadow: 0 0 0 1px var(--color-blue-dark);
      }
    }
  }

  &[disabled]:not([disabled='false']),
  &[readonly] {
    div[data-ref='select-input-container'],
    div[data-ref='disclosure-icon'] {
      background-color: var(--color-gray-lightest);
      border-color: var(--color-gray-lighter);
      border-radius: 4px;
      cursor: not-allowed;
    }
    div[data-ref='select-input-container']:focus {
      box-shadow: none;
    }
    div[data-ref='select-input-container']:hover {
      border-color: var(--color-gray-lighter);
    }
  }

  &[disabled]:not([disabled='false']) {
    div[data-ref='disclosure-icon'] s-icon,
    div[data-ref='select-input-container'],
    button[data-ref='deselect-all-button'] {
      color: var(--color-gray-light);
    }
  }

  &[readonly] {
    div[data-ref='disclosure-icon'] s-icon,
    div[data-ref='select-input-container'],
    button[data-ref='deselect-all-button'] {
      color: var(--color-gray-dark);
    }
  }

  /* 
    Fixes IE11 s-select width bug with border-box: https://github.com/philipwalton/flexbugs#flexbug-7 
    By scoping to single select, we don't change multi-select ability to input on same line as a selection tag
  */
  @media (-ms-high-contrast: none), (-ms-high-contrast: active) {
    &:not([multiple]) {
      div[data-ref='select-input-container'] {
        flex-basis: auto;
        width: 100%;
      }
    }
  }
}
